import { Injectable } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { AuthenticationService } from "./authentication.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalCtaComponent } from "../corporate/modal-cta/modal-cta.component";

@Injectable()
export class CtaService {
  constructor(private modalService: NgbModal) {}


  public showCTA(formId: string) {
    const modalRef = this.modalService.open(ModalCtaComponent, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static'
    });

    modalRef.componentInstance.formId = formId;

  }
}
